export default (
  stroke = '#1043E7'
) => `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 36L15.4059 23.0294L8.09995 27.9L12.9705 20.5941L0 18L12.9706 15.4059L8.09994 8.09995L15.4059 12.9706L18 0L20.5941 12.9705L27.9 8.09994L23.0294 15.4059L36 18L23.0294 20.5941L27.9 27.9L20.5941 23.0294L18 36Z" fill="${stroke}"/>
</svg>
`;
